import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/home',
      name: 'Home',
      component:resolve=>require(['@/views/home'],resolve),
      children:[
        {
          path: '/examinee/basicinfo',
          name: 'basicinfo',
          component:resolve=>require(['@/views/examinee/basic_info'],resolve)
        },
        {
          path: '/examinee/mypicture',
          name: 'mypicture',
          component:resolve=>require(['@/views/examinee/my_picture'],resolve)
        },
        {
          path: '/examinee/mycertificate',
          name: 'mycertificate',
          component:resolve=>require(['@/views/examinee/my_certificate'],resolve)
        },
        {
          path: '/examinee/certificate_status',
          name: 'certificate_status',
          component:resolve=>require(['@/views/examinee/certificate_status'],resolve)
        },
        {
          path: '/examinee/enroll',
          name: 'enroll',
          component:resolve=>require(['@/views/examinee/enroll'],resolve)
        },
        {
          path: '/examinee/enrollinfo',
          name: 'enrollinfo',
          component:resolve=>require(['@/views/examinee/enroll_info'],resolve)
        },
        {
          path: '/examinee/enrolldetail/:examPostMessageId',
          name: 'enrolldetail',
          component:resolve=>require(['@/views/examinee/enroll_detail'],resolve)
        },
        {
          path: '/examinee/printadmissionticket',
          name: 'printadmissionticket',
          component:resolve=>require(['@/views/examinee/print_admission_ticket'],resolve)
        },
        {
          path: '/examinee/grade',
          name: 'grade',
          component:resolve=>require(['@/views/examinee/grade'],resolve)
        },
        {
          path: '/admin/exampolicy',
          name: 'exampolicy',
          component:resolve=>require(['@/views/admin/exam_policy'],resolve)
        },
        {
          path: '/admin/examdynamic',
          name: 'examdynamic',
          component:resolve=>require(['@/views/admin/exam_dynamic'],resolve)
        },
        {
          path: '/admin/examrelease',
          name: 'examrelease',
          component:resolve=>require(['@/views/admin/exam_release'],resolve)
        },
        {
          path: '/admin/examapproval',
          name: 'examapproval',
          component:resolve=>require(['@/views/admin/exam_approval'],resolve)
        },
        {
          path: '/admin/examinationroom',
          name: 'examinationroom',
          component:resolve=>require(['@/views/admin/examination_room'],resolve)
        },
        {
          path: '/admin/examapprovaldetail/:examUserId/:examUserPostId',
          name: 'examapprovaldetail',
          component:resolve=>require(['@/views/admin/exam_approval_detail'],resolve)
        },
        {
          path: '/admin/examstatistics',
          name: 'examstatistics',
          component:resolve=>require(['@/views/admin/exam_statistics'],resolve)
        },
        {
          path: '/admin/exampolicycreate/:examPolicyId/:examPolicyState',
          name: 'exampolicycreate',
          component:resolve=>require(['@/views/admin/exam_policy_create'],resolve)
        },
        {
          path: '/admin/examdynamiccreate/:examDynamicId/:examDynamicState',
          name: 'examdynamiccreate',
          component:resolve=>require(['@/views/admin/exam_dynamic_create'],resolve)
        },
        {
          path: '/admin/examreleasecreate/:examPostMessageId/:examPostMessageState',
          name: 'examreleasecreate',
          component:resolve=>require(['@/views/admin/exam_release_create'],resolve)
        },
        {
          path: '/admin/admissionticket',
          name: 'admissionticket',
          component:resolve=>require(['@/views/admin/admission_ticket'],resolve)
        },
        {
          path: '/admin/massTexting',
          name: 'massTexting',
          component:resolve=>require(['@/views/admin/mass_texting'],resolve)
        },
        {
          path: '/admin/admissionticketcreate',
          name: 'admissionticketcreate',
          component:resolve=>require(['@/views/admin/admission_ticket_create'],resolve)
        },
        {
          path: '/admin/scoreinput',
          name: 'scoreinput',
          component:resolve=>require(['@/views/admin/score_input'],resolve)
        },
        {
          path: '/admin/scorequery',
          name: 'scorequery',
          component:resolve=>require(['@/views/admin/score_query'],resolve)
        },
        {
          path: '/admin/examsubjects',
          name: 'examsubjects',
          component:resolve=>require(['@/views/admin/exam_subjects'],resolve)
        },
        {
          path: '/admin/certificategetuser',
          name: 'certificategetuser',
          component:resolve=>require(['@/views/admin/certificate_get_user'],resolve)
        },
        {
          path: '/admin/certificatepost',
          name: 'certificatepost',
          component:resolve=>require(['@/views/admin/certificate_post'],resolve)
        },
        {
          path: '/admin/certificateprinting',
          name: 'certificateprinting',
          component:resolve=>require(['@/views/admin/certificate_printing'],resolve)
        },
        {
          path: '/admin/certificatefinish',
          name: 'certificatefinish',
          component:resolve=>require(['@/views/admin/certificate_finish'],resolve)
        },
        {
          path: '/admin/certificatehistory',
          name: 'certificatehistory',
          component:resolve=>require(['@/views/admin/certificate_history'],resolve)
        },
        {
          path: '/admin/usermanage',
          name: 'usermanage',
          component:resolve=>require(['@/views/admin/user_manage'],resolve)
        },
        {
          path: '/admin/rolemanage',
          name: 'rolemanage',
          component:resolve=>require(['@/views/admin/role_manage'],resolve)
        },
        {
          path: '/admin/agreementmanage',
          name: 'agreementmanage',
          component:resolve=>require(['@/views/admin/agreement_manage'],resolve)
        },
        {
          path: '/admin/liveediting',
          name: 'liveediting',
          component:resolve=>require(['@/views/admin/live_editing'],resolve)
        },
        {
          path: '/admin/liveeditingcreate/:examWorkId/:examWorkState',
          name: 'liveeditingcreate',
          component:resolve=>require(['@/views/admin/live_editing_create'],resolve)
        },
        {
          path: '/admin/Certificate_details',
          name: 'Certificatedetails',
          component:resolve=>require(['@/views/admin/Certificate_details'],resolve)
        },
        {
          path: '/admin/ets_setup',
          name: 'etssetup',
          component:resolve=>require(['@/views/admin/ets_setup'],resolve)
        },
        {
          path: '/examinee/new_est',
          name: 'newest',
          component:resolve=>require(['@/views/examinee/new_est'],resolve)
        },
        {
          path: '/admin/Your_admission_ticket',
          name: 'Your_admission_ticket',
          component:resolve=>require(['@/views/admin/Your_admission_ticket'],resolve)
        },
        
        {
          path: '/examinee/new_Candidate_Number',
          name: 'new_Candidate_Number',
          component:resolve=>require(['@/views/examinee/new_Candidate_Number'],resolve)
        },
        {
          path: '/examinee/exammanagementt',
          name: 'exammanagementt',
          component:resolve=>require(['@/views/examinee/exam_managementt'],resolve)
        },
      ]
    },
    {
      path: '/',
      name: 'login_a',
      component:resolve=>require(['@/views/login'],resolve)
    },
    {
      path: '/register',
      name: 'register',
      component:resolve=>require(['@/views/register'],resolve)
    },
    {
      name: 'agreementdetail',
      path: '/examinee/agreementdetail/:id',
      component:resolve=>require(['@/views/examinee/agreement_detail'],resolve)
    },
    {
      path: '/examinee/examinationpolicy',
      name: 'examinationpolicy',
      component:resolve=>require(['@/views/examinee/examination_policy'],resolve)
    },
    {
      path: '/examinee/infoDetail',
      name: 'infoDetail',
      component:resolve=>require(['@/views/examinee/infoDetail'],resolve)
    },
    {
      path: '/examinee/supplierAllBack',
      name: 'supplierAllBack',
      component:resolve=>require(['@/views/examinee/supplierAllBack'],resolve)
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js